import { render, staticRenderFns } from "./FilterWithSearch.vue?vue&type=template&id=1289cb20&"
import script from "./FilterWithSearch.vue?vue&type=script&lang=js&"
export * from "./FilterWithSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports